export default __webpack_public_path__ + "static/media/slide-4.2ce36462.png";